import React from 'react';
import Container from '@/components/layout/Container';
import ModularZone from '../modular_zone';
import Image from 'next/image';

const TitleSection = ({ block, position }) => {
  const {
    pretext,
    title,
    title_description,
    text_color_picker,
    background_color_picker,
    background_image,
    modular_blocks,
    _metadata
  } = block?.title_section;

  const imageDesktop = background_image?.desktop_image;
  const imageTablet = background_image?.tablet_image;
  const imageMobile = background_image?.mobile_image;

  const backgroundColorClass = `bg-[${background_color_picker}]`;
  const textColorClass = `text-[${text_color_picker}]`;

  return (
    <section
      id={_metadata.uid + '_' + position}
      className={`relative overflow-hidden text-center ${backgroundColorClass}`}
      data-name="title-section"
    >
      {imageDesktop && imageTablet && imageMobile && (
        <BackgroundImage
          show={background_image.show_background_image}
          imageDesktop={imageDesktop}
          imageTablet={imageTablet}
          imageMobile={imageMobile}
        />
      )}
      <div
        className={`standard-padding ${
          background_image.show_background_image
            ? 'absolute z-10 flex h-full w-full items-center justify-center'
            : ''
        }`}
      >
        <Container className="p-4">
          <PreText data={pretext} color={textColorClass} />
          <h1 className={`h3 sm:h2 mb-2 ${textColorClass}`}>{title}</h1>
          <p className="sh8">{title_description}</p>
          {modular_blocks && <ModularZone block={modular_blocks} />}
        </Container>
      </div>
    </section>
  );
};

export default TitleSection;

const PreText = ({ data, color }) => {
  return data?.title_pretext ? (
    <span className={color}>{data.title_pretext}</span>
  ) : null;
};

const BackgroundImage = ({ show, imageDesktop, imageTablet, imageMobile }) => {
  if (!show || !imageDesktop || !imageTablet || !imageMobile) {
    return null;
  }

  return (
    <picture>
      <source
        media="(max-width: 767px)"
        srcSet={`${imageMobile.url}, ${imageMobile.url}?dpr=2 2x`}
      />
      <source
        media="(min-width: 768px) and (max-width: 1024px)"
        srcSet={`${imageTablet.url}, ${imageTablet.url}?dpr=2 2x`}
      />
      <Image
        src={imageDesktop.url}
        alt={imageDesktop.title}
        fill
        sizes="100vw"
      />
    </picture>
  );
};
